export default function AlgoritmoSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Come Funziona il BCI
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            Un algoritmo proprietario che integra 47 variabili critiche per una valutazione 
            completa, accurata e scientificamente rigorosa del valore del brand.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl font-bold text-white">1</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Raccolta Dati</h3>
            <p className="text-gray-300 leading-relaxed">
              Acquisizione sistematica di tutti gli indicatori finanziari, di mercato, 
              reputazionali e operativi che influenzano il valore del brand.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl font-bold text-white">2</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Elaborazione BCI</h3>
            <p className="text-gray-300 leading-relaxed">
              Applicazione dell'algoritmo proprietario che pondera e correla tutti 
              i parametri secondo coefficienti scientificamente validati.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#E879F9] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl font-bold text-white">3</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Perizia Certificata</h3>
            <p className="text-gray-300 leading-relaxed">
              Generazione di una valutazione completa, documentata e legalmente 
              difendibile con tutti i riferimenti metodologici.
            </p>
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-12">
          <h3 className="text-3xl font-bold text-white text-center mb-12">
            Le 5 Dimensioni del BCI
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">Dimensione Finanziaria</h4>
              <ul className="text-sm text-gray-300 space-y-1">
                <li>• Ricavi attribuibili al brand</li>
                <li>• Marginalità specifica</li>
                <li>• Crescita storica</li>
                <li>• Volatilità dei flussi</li>
              </ul>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-bar-chart-box-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">Dimensione di Mercato</h4>
              <ul className="text-sm text-gray-300 space-y-1">
                <li>• Quote di mercato</li>
                <li>• Posizionamento competitivo</li>
                <li>• Barriere all'entrata</li>
                <li>• Dinamiche settoriali</li>
              </ul>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">Dimensione Reputazionale</h4>
              <ul className="text-sm text-gray-300 space-y-1">
                <li>• Brand awareness</li>
                <li>• Customer loyalty</li>
                <li>• Net Promoter Score</li>
                <li>• Sentiment analysis</li>
              </ul>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">Dimensione Legale</h4>
              <ul className="text-sm text-gray-300 space-y-1">
                <li>• Protezione IP</li>
                <li>• Registrazioni marchi</li>
                <li>• Contenzioso attivo</li>
                <li>• Compliance normativa</li>
              </ul>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#E879F9] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-settings-3-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">Dimensione Operativa</h4>
              <ul className="text-sm text-gray-300 space-y-1">
                <li>• Efficienza operativa</li>
                <li>• Qualità processi</li>
                <li>• Innovazione R&D</li>
                <li>• Sostenibilità ESG</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#E879F9] to-[#22C55E] text-white rounded-full text-lg font-medium">
            <i className="ri-formula text-xl mr-2"></i>
            BCI = Σ(Dimensioni × Pesi × Coefficienti di Rischio)
          </div>
          <p className="text-gray-300 mt-4 max-w-2xl mx-auto">
            Formula semplificata dell'algoritmo BCI. La metodologia completa include 
            47 variabili ponderate secondo coefficienti proprietari validati empiricamente.
          </p>
        </div>
      </div>
    </section>
  );
}